
import React from "react";

import { Badge} from "react-bootstrap";

export default function ScenarioTag(props) {
	
	const s = props.scenario;
	
	
	if(!s.scenarioid)
		return (<Badge bg="default">Default</Badge>)
	
	if(!s.tag)
		return '';
		
	return (<Badge bg="" style={{backgroundColor:s.tag.color}} >{s.tag.name}</Badge>)
	
	
}